import { useDataProvider } from "react-admin";
import { useQuery } from "react-query";

import {
  ActiveUserCountsForFinancesResponse,
  CustomDataProvider,
} from "../../../../types";
import { ChartContainer, LineChart } from "../../../custom";
import { analyticsUtils } from "../../analytics-utils";

function ProjectedEnterprisePlanOveragesMrrChart() {
  const dataProvider = useDataProvider<CustomDataProvider>();

  const { data } = useQuery<{
    data: ActiveUserCountsForFinancesResponse[];
  }>(["getActiveUserCountsForFinances"], () =>
    dataProvider.getActiveUserCountsForFinances(),
  );

  if (data?.data) {
    const processedData = analyticsUtils.processData(
      data.data,
      new ActiveUserCountsForFinancesResponse(),
      30,
    );

    return (
      <ChartContainer title="Projected Enterprise Plan Overages (MRR)">
        <LineChart
          labels={processedData.map(
            (d: ActiveUserCountsForFinancesResponse) => d.date,
          )}
          datasets={[
            {
              data: processedData.map(
                (d: ActiveUserCountsForFinancesResponse) =>
                  d.enterprise_estimated_overage_mmr,
              ),
              label: "Overage",
            },
          ]}
        />
      </ChartContainer>
    );
  } else {
    return null;
  }
}

export default ProjectedEnterprisePlanOveragesMrrChart;
